import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import * as lessonApi from '@/api/lesson'
import { MicrocoursePlayer } from '@/components/microcourse'
import type { Lesson } from '@/types/lesson'
import type { MicrocourseProject } from '@ai-tutor/shared'
import { normalizeDeck } from '@ai-tutor/shared'

export default function SharedLessonPage() {
  const { token } = useParams<{ token: string }>()
  const [lesson, setLesson] = useState<Lesson | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!token) return
    lessonApi
      .getSharedLesson(token)
      .then((raw: any) => {
        const normalized = { ...raw, deck: raw.deck ? normalizeDeck(raw.deck, raw.id) : null }
        setLesson(normalized)
      })
      .catch((e) => setError(e instanceof Error ? e.message : '加载失败'))
      .finally(() => setLoading(false))
  }, [token])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-muted-foreground">加载中...</div>
      </div>
    )
  }

  if (error || !lesson) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center space-y-2">
          <div className="text-red-500">{error ?? '课件不存在'}</div>
          <div className="text-sm text-muted-foreground">分享链接可能已过期</div>
        </div>
      </div>
    )
  }

  const project = lesson.deck as MicrocourseProject | undefined
  if (!project) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-muted-foreground">课件数据为空</div>
      </div>
    )
  }

  return (
    <div className="flex flex-col h-screen">
      {/* Header */}
      <div className="flex items-center px-4 py-2 border-b bg-background">
        <h1 className="text-lg font-semibold">{project.title}</h1>
        <span className="ml-2 text-xs text-muted-foreground">· 分享的微课</span>
      </div>

      {/* Unified player */}
      <div className="flex-1 min-h-0">
        <MicrocoursePlayer project={project} />
      </div>
    </div>
  )
}
